export const VERCEL_AI_DATA_STREAM_HEADER = "X-Vercel-AI-Data-Stream";
export const INTERNAL_SERVICE_KEY_HEADER = "X-Internal-Service-Key";
export const CORRELATION_ID_HEADER = "x-correlation-id";
export const TOOL_CALL_ID_HEADER = "x-tool-call-id";
export const HUMAN_AUTHORIZED_HEADER = "x-human-authorized";

/**
 * Stable machine-readable error codes for campaign archival (embedded in
 * error messages so they survive the MCP transport, where typed error
 * classes are flattened to strings — see the archival plan's D2).
 */
export const CAMPAIGN_ARCHIVED_ERROR_CODE = "campaign_archived";
export const CAMPAIGN_HAS_PERMANENT_CHARACTER_ERROR_CODE =
  "campaign_has_permanent_character";
